import ArrowCircleDownOutlinedIcon from '@mui/icons-material/ArrowCircleDownOutlined'
import ArrowCircleUpOutlinedIcon from '@mui/icons-material/ArrowCircleUpOutlined'
import { Tab, Tabs } from '@mui/material'
import { CompanyUsersStatus } from '@shared/types/companies.types'
import { Permission } from '@shared/types/roles.types'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink, Outlet, useParams } from 'react-router'
import { useAuthStore } from '../hooks/useAuthStore'
import {
  useCompanyUser,
  useCompanyUsers
} from '../hooks/useQueries/useCompanies'

const tabStyles = {
  textTransform: 'none !important',
  '& .MuiTab-label': {
    textTransform: 'none !important'
  },
  '&.active': {
    color: 'primary.main',
    borderBottom: '2px solid',
    borderColor: 'primary.main'
  }
}

export default function InvitationsLayout() {
  const { t } = useTranslation()
  const { companyId } = useParams() as { companyId: string }
  const { userId } = useAuthStore()

  const { data: userCompany } = useCompanyUser(companyId!, userId!)
  const { data: sentInvitations } = useCompanyUsers(companyId, {
    status: CompanyUsersStatus.PENDING_USER
  })
  const { data: receivedInvitations } = useCompanyUsers(companyId, {
    status: CompanyUsersStatus.PENDING_COMPANY
  })

  const canManageMembers = useMemo(() => {
    return (
      userCompany?.permissions?.includes(Permission.USERS_ACCEPT) ||
      userCompany?.role?.fullAccess
    )
  }, [userCompany])

  return (
    <>
      {canManageMembers && (
        <Tabs value={false} aria-label='invitations tabs'>
          <Tab
            component={NavLink}
            to={`/companies/${companyId}/invitations/sent`}
            icon={<ArrowCircleUpOutlinedIcon />}
            label={t('invitations_view.tabs.sent', {
              count: sentInvitations?.length
            })}
            iconPosition='start'
            sx={tabStyles}
          />
          <Tab
            component={NavLink}
            to={`/companies/${companyId}/invitations/received`}
            icon={<ArrowCircleDownOutlinedIcon />}
            label={t('invitations_view.tabs.received', {
              count: receivedInvitations?.length
            })}
            iconPosition='start'
            sx={tabStyles}
          />
        </Tabs>
      )}
      <Outlet />
    </>
  )
}
